import React, { useState, useEffect } from 'react';
import ChooseBrikTypeName from './ChooseBrikTypeName';
import {
  STEP_CREATE_BRIK,
  TYPE_BRIK,
  TYPE_PAYMENT_BRIK,
} from 'utils';
import CreateDetailBrik from './CreateDetailBrik';
import ChooseBrikType from './ChooseBrikType';
import ChooseSectionType from './ChooseSectionType';
import { ChooseBrikJourney } from "./ChooseBrikJourney";
import { ChooseBrikSchedule } from "./ChooseBrikSchedule";
import useStyles from './styles';

const CreateBrik = React.forwardRef((props: any, ref: any) => {
  const classes = useStyles();

  const { itemEdit, isEdit, typeBrikGroup, isFromDetail } = props;

  const [typeLength, setTypeLength] = useState<number>(-1);
  const [step, setStep] = useState(0);
  const [typeName, setTypeName] = useState<number>(); //TYPE_NAME_BRIK.LESSON
  const [typeBrik, setTypeBrik] = useState<number>(); //TYPE_BRIK.SUBSCRIBERS
  const [typeSection, setTypeSection] = useState('');
  const [typePayment, setTypePayment] = useState<number>(
    TYPE_PAYMENT_BRIK.SUBCRIPTION
  );
  const [isTypeBrik, setIsTypeBrik] = useState<boolean>(true);

  const nextStep = (e: any, type: any) => {
    if (type === 6 || type === 7) {
      setStep(step + 1);
    } else {
      if (type === 1 || type === 2) {
        if (step === 1) {
          setStep(3);
        }else {
          setStep(step + 1);
        }
      } else {
        if (step === 2) {
          setStep(4);
        } else if (step === 3) {
          setStep(2);
        } else {
          setStep(step + 3);
        }
      }
    }
  };

  const backStep = (e: any, type: any) => {
    if (type === 6 || type === 7) {
      setStep(step - 1);
    } else {
      if (type === 1 || type === 2) {
        if (step === 3) {
          setStep(1);
        } else if (step === 1) {
          setStep(0);
        } else {
          setStep(step - 1);
        }
      } else {
        if (step === 2) {
          setStep(3);
        } else if (step === 3) {
          setStep(0);
        } else {
          setStep(2);
        }
      }
    }

  };

  const handleSetTypeName = (type: any) => {
    if (type === 6 || type === 7) {
      setTypeLength(2);
    } 
    setTypeName(type);
  };

  const handleTypeBrik = (type: any) => {
    setIsTypeBrik(false);
    setTypeBrik(type);

    if (type === TYPE_BRIK.GROUPS) {
      setTypePayment(TYPE_PAYMENT_BRIK.ONE_TIME);
    } else {
      setTypePayment(TYPE_PAYMENT_BRIK.SUBCRIPTION);
    }
  };

  useEffect(() => {
    if (itemEdit) {
      setStep(STEP_CREATE_BRIK.CREATE_BRIK_DETAIL);
      setTypeBrik(itemEdit?.type_brik);
      setTypePayment(itemEdit?.type_payment);
      setTypeLength(itemEdit?.length);
    }
    if (typeBrikGroup) {
      setTypeBrik(1);
      setIsTypeBrik(false);
      setTypePayment(TYPE_PAYMENT_BRIK.ONE_TIME);
    }
  }, [typeBrikGroup]);

  const refresh = async () => {

  };

  const renderContent = () => {
    switch (step) {
      case STEP_CREATE_BRIK.CHOOSE_BRIK_TYPE_NAME:
        return (
          <ChooseBrikTypeName
            nextStep={nextStep}
            handleSetTypeName={handleSetTypeName}
            backStep={backStep}
          />
        );
      case STEP_CREATE_BRIK.CHOOSE_BRIK_TYPE_TYPE:
        return (
          <ChooseBrikJourney
            backStep={backStep}
            nextStep={nextStep}
            type={typeName}
            handleSetTypeName={handleSetTypeName}
          />
        );
      case STEP_CREATE_BRIK.CHOOSE_BRIK_SCHEDULE:
        return (
          <ChooseBrikSchedule
            backStep={backStep}
            nextStep={nextStep}
            type={typeName}
            typeLength={typeLength}
            setTypeLength={function (type: number): void {
              setTypeLength(type)
            }}
          />
        );
      case STEP_CREATE_BRIK.CHOOSE_BRIK_TYPE:
        return (
          <ChooseBrikType
            backStep={backStep}
            nextStep={nextStep}
            isEdit={isEdit}
            handleTypeBrik={handleTypeBrik}
            typeBrik={typeBrik}
            typeName={typeName}
            isTypeBrik={isTypeBrik}
            typeBrikGroup={typeBrikGroup}
          />
        );
      case STEP_CREATE_BRIK.CREATE_BRIK_DETAIL:
        return (
          <CreateDetailBrik
            nextStep={nextStep}
            backStep={backStep}
            itemEdit={itemEdit}
            typeBrik={typeBrik}
            typeName={typeName}
            typePayment={typePayment}
            setTypePayment={setTypePayment}
            isEdit={isEdit}
            isFromDetail={isFromDetail}
            isDuplicate={false}
            typeLength={typeLength}
            refresh={refresh}
            handleTypeBrik={handleTypeBrik}
          />
        );
      case STEP_CREATE_BRIK.CHOOSE_BRIK_SECTION:
        return (
          <ChooseSectionType
            backStep={backStep}
            setTypeSection={setTypeSection}
            typeSection={typeSection}
            typeName={typeName}
          />
        );
    }
  };

  return <div className={classes.container}>{renderContent()}</div>;
});

export default CreateBrik;
